/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Expense_Rule_Reorder_IncompleteInputs */

const vi_error_expense_rule_reorder_incomplete = /** @type {(inputs: Error_Expense_Rule_Reorder_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách quy tắc vừa thay đổi. Tải lại trang rồi sắp xếp lại.`)
};

/**

* @param {Error_Expense_Rule_Reorder_IncompleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_expense_rule_reorder_incomplete = /** @type {((inputs?: Error_Expense_Rule_Reorder_IncompleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Expense_Rule_Reorder_IncompleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_expense_rule_reorder_incomplete(inputs)
});